import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import './Blog.css';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const query = `
          query {
            publication(host: "hashnode.iburtum.xyz") {
              id
              isTeam
              title
              posts(first:50) {
                edges {
                  node {
                    id
                    title
                    brief
                    coverImage {
                      url
                    }
                    url
                    slug
                    publishedAt
                    readTimeInMinutes
                  }
                }
              }
            }
          }
        `;

        const response = await axios.post('https://gql.hashnode.com', { query });
        setPosts(response.data.data.publication.posts.edges);
      } catch (error) {
        console.error('Error fetching posts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-box">
          <div className="spinner"></div>
          <div className="loading-text">جار التحميل...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-container">
      {posts.map((post, index) => (
        <motion.div
          key={post.node.id}
          className="post-card"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {post.node.coverImage && (
            <img src={post.node.coverImage.url} alt={post.node.title} className="cover-image" />
          )}
          <h3>{post.node.title}</h3>
          <div className="post-meta">
            <span>تاريخ النشر: {new Date(post.node.publishedAt).toLocaleDateString()}</span>
            <span>وقت القراءة: {post.node.readTimeInMinutes} دقيقة</span>
          </div>
          <p>{post.node.brief.length > 100 ? post.node.brief.slice(0, 100) + '...' : post.node.brief}</p>
          <div className="post-card-footer">
            <button onClick={() => navigate(`/blog/${post.node.slug}`)}>المزيد</button>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default Blog;